<template>
    <div class="page">
        <div class="login-page">
            <div class="login-icon">
                <img :src="loadIcon" alt="Logo"/>
            </div>
            <div class="login-title">
                <h3>{{$t('app.name')}}</h3>
                <h3 v-if='finished'>{{$t('remerciements.note.reclamation.success')}}</h3>
                <h3 v-if='error'>{{$t('remerciements.note.reclamation.error')}}</h3>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import noteReclamationService from '@/modules/NoteReclamation/services/NoteReclamationService';
import { NOTE_RECLAMATION } from '@/modules/NoteReclamation/store/mutation-types';

export default defineComponent({
    name: 'NoteReclamation.vue',
    components: { },
    data() {
        return {
            error: false,
            finished: false
        };
    },
    beforeMount() {
        this.$store.commit(`noteReclamationState/${NOTE_RECLAMATION.SET_JWT}`, this.$route.params.jwt);
        noteReclamationService.noterReclamation(+this.$route.params.reclamationId, +this.$route.params.note)
            .then(() => {
                this.finished = true;
                this.$store.commit(`noteReclamationState/${NOTE_RECLAMATION.RESET_JWT}`);
                this.$router.replace('/noteReclamation');
            })
            .catch(() => {
                this.error = true;
                this.$store.commit(`noteReclamationState/${NOTE_RECLAMATION.RESET_JWT}`);
                this.$router.replace('/noteReclamation');
            });
    },
    computed:{
        loadIcon(){
            return require('@/assets/img/logo.svg');
        },
    },
    methods:{

    }
});
</script>

<style scoped>
.page {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.login-page {
    text-align: center;
}
.login-icon img{
    border: 1px solid var(--medium-light-grey);
    border-radius: 10px;
    width: 150px;
    height: 150px;
}
.login-title h3{
    font-size: var(--font-size-high-medium);
    font-weight: var(--font-weight-normal);
    font-style: var(--font-style-normal);
    margin: 30px 0 20px 0;
    color: var(--color-principal);
}
@media screen and (max-height: 900px) {
    .login-icon img {
        width: 90px;
        height: 90px;
    }
    .login-title h3{
        margin: 20px 0 10px 0;
    }
}
</style>
